module.exports = __webpack_public_path__ + "images/6a2a472.png";